"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _noImportant = require("aphrodite/no-important");

var _DayPicker = _interopRequireDefault(require("react-day-picker/DayPicker"));

var _providers = require("../../../toolkit/providers");

var _localization = require("../../../toolkit/localization");

var _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* babel-plugin-inline-import '../../../img/chevron-right.svg' */

/* Lego Toolkit */

/* SVGs */
var rightArrow = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgxNnYxNkgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InJvdGF0ZSgtOTAgOCA4KSI+CiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iI0M3MzUzNSIgZmlsbC1vcGFjaXR5PSIwIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDxnIGZpbGw9IiMxNTI5MzQiIG1hc2s9InVybCgjYikiPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InNjYWxlKDEgLTEpIHJvdGF0ZSg0NSAxOS43NzggMy4xMjEpIj4KICAgICAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIxMCIgaGVpZ2h0PSIyIiByeD0iMSIvPgogICAgICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjIiIGhlaWdodD0iMTAiIHJ4PSIxIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";

var DayPicker = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DayPicker, _Component);

  var _super = _createSuper(DayPicker);

  function DayPicker() {
    var _this;

    (0, _classCallCheck2["default"])(this, DayPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;

    _this.formatMonthTitle = function (d) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "nonZh";
      var hideYear = _this.props.hideYear;

      if (hideYear) {
        if (locale == "zh") {
          // 1月
          return "".concat(_this.months.zh[d.getMonth()]);
        } // January


        return "".concat(_this.months.nonZh[d.getMonth()]);
      }

      if (locale == "zh") {
        // 2018年1月
        return "".concat(d.getFullYear(), "\u5E74").concat(_this.months.zh[d.getMonth()]);
      } // January 2018


      return "".concat(_this.months.nonZh[d.getMonth()], " ").concat(d.getFullYear());
    };

    _this.formatDay = function (d) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "nonZh";

      var month = _this.formatMonthTitle(d, locale);

      if (locale == "zh") {
        // 2018年1月1日 星期一
        return "".concat(month).concat(d.getDate(), "\u65E5 ").concat(_this.weekdaysLong.zh[d.getDay()]);
      } // Monday, 1 January 2018


      return "".concat(_this.weekdaysLong.nonZh[d.getDay()], ", ").concat(month);
    };

    _this.formatWeekdayShort = function (i) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "nonZh";

      if (locale == "zh") {
        return _this.weekdaysShort.zh[i];
      }

      return _this.weekdaysShort.nonZh[i];
    };

    _this.formatWeekdayLong = function (i) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "nonZh";

      if (locale == "zh") {
        return _this.weekdaysShort.zh[i];
      }

      return _this.weekdaysShort.nonZh[i];
    };

    _this.getFirstDayOfWeek = function () {
      var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "nonZh";
      return 1;
    };

    _this.dateLocaleUtils = {
      formatDay: _this.formatDay,
      formatMonthTitle: _this.formatMonthTitle,
      formatWeekdayShort: _this.formatWeekdayShort,
      formatWeekdayLong: _this.formatWeekdayLong,
      getFirstDayOfWeek: _this.getFirstDayOfWeek
    };
    return _this;
  }

  (0, _createClass2["default"])(DayPicker, [{
    key: "getDisabledStyle",
    value: function getDisabledStyle() {
      var theme = this.context.theming.theme;

      if (DayPicker.disabledStyle.hasOwnProperty("disabled")) {
        return DayPicker.disabledStyle;
      }

      var styles = _noImportant.StyleSheet.create({
        disabled: {
          color: "".concat(theme.textBlack, " !important"),
          // @ts-ignore "0.2 !important" is a hack to
          // insert !important into daypicker library.
          opacity: "0.2 !important",
          cursor: "default !important",
          ":hover": {
            background: "none !important"
          }
        }
      });

      DayPicker.disabledStyle.disabled = (0, _noImportant.css)(styles.disabled);
      return DayPicker.disabledStyle;
    }
  }, {
    key: "weekdayElement",
    value: function weekdayElement(props) {
      var weekday = props.weekday,
          className = props.className,
          localeUtils = props.localeUtils,
          locale = props.locale;
      var weekdayShort = localeUtils.formatWeekdayShort(weekday, locale);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, weekdayShort);
    }
  }, {
    key: "render",
    value: function render() {
      // We're hacking `classNames` here, not good
      var dayPickerClassNames = {};
      var locale = this.props.locale;
      var styles = this.dayPickerStyles;
      Object.keys(styles).forEach(function (key) {
        if (dayPickerClassNames != null) {
          dayPickerClassNames[key] = (0, _noImportant.css)(styles[key]);
        }
      });
      var disabledStyle = this.getDisabledStyle();

      if (dayPickerClassNames != null) {
        dayPickerClassNames.disabled = disabledStyle.disabled;
      }

      return /*#__PURE__*/_react["default"].createElement(_DayPicker["default"], (0, _extends2["default"])({
        locale: locale || "en",
        localeUtils: this.dateLocaleUtils,
        classNames: dayPickerClassNames,
        weekdayElement: this.weekdayElement
      }, this.props));
    }
  }, {
    key: "dayPickerStyles",
    // Styles copied from node_modules/react-day-picker/lib/styles.css,
    // make it fit into the Aphrodite framework.
    // Did some modifications to satisfy our design request
    get: function get() {
      var _this$context$theming = this.context.theming,
          theme = _this$context$theming.theme,
          fonts = _this$context$theming.fonts;
      var navButton = {
        position: "absolute",
        top: "1em",
        display: "inline-block",
        marginTop: 2,
        width: "1.25em",
        height: "1.25em",
        backgroundImage: "url(".concat(rightArrow, ")"),
        backgroundPosition: "center",
        backgroundSize: "50%",
        backgroundRepeat: "no-repeat",
        cursor: "pointer",
        opacity: 0.8,
        borderRadius: "50%",
        transition: "all 0.2s linear",
        ":hover": {
          opacity: 1,
          backgroundColor: theme.borderPrimary
        }
      };
      var showOutsideDays = this.props.showOutsideDays;
      return _noImportant.StyleSheet.create({
        container: {
          display: "inline-block",
          fontSize: 16,
          color: theme.textBlack
        },
        wrapper: {
          display: "flex",
          position: "relative",
          flexDirection: "row",
          paddingBottom: "1em",
          userSelect: "none"
        },
        interactionDisabled: {
          cursor: "default"
        },
        navBar: {},
        // @ts-ignore adding this class as hack so
        // daypicker component can use it.
        navButtonPrev: _objectSpread({
          left: "0.5em",
          transform: "rotate(180deg)"
        }, navButton),
        // @ts-ignore adding this class as hack so
        // daypicker component can use it.
        navButtonNext: _objectSpread({
          right: "0.5em"
        }, navButton),
        navButtonInteractionDisabled: {
          display: "none"
        },
        months: {
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center"
        },
        month: {
          width: "100%",
          display: "table",
          marginLeft: 0,
          marginRight: 0,
          marginTop: "1em",
          borderSpacing: 0,
          borderCollapse: "collapse",
          userSelect: "none"
        },
        caption: {
          display: "table-caption",
          marginBottom: "0.5em",
          padding: "0 0.5em",
          textAlign: "center",
          color: theme.textDark,
          fontFamily: fonts.semibold,
          fontSize: "1.15em"
        },
        weekdays: {
          display: "table-header-group",
          marginTop: "1em"
        },
        weekdaysRow: {
          display: "table-row"
        },
        weekday: {
          display: "table-cell",
          padding: "0.5em",
          color: theme.textDark,
          textAlign: "center",
          fontSize: "0.875em"
        },
        weekNumber: {
          display: "table-cell",
          padding: "0.5em",
          borderRadius: "50%",
          verticalAlign: "middle",
          textAlign: "center",
          fontSize: "0.875em",
          color: theme.textDark,
          borderRight: "1px solid ".concat(theme.surfaceLight)
        },
        body: {
          display: "table-row-group"
        },
        week: {
          display: "table-row"
        },
        day: {
          display: "table-cell",
          padding: "0.5em",
          borderRadius: "50%",
          verticalAlign: "middle",
          textAlign: "center",
          cursor: "pointer",
          transition: "background-color 0.2s linear",
          ":hover": {
            backgroundColor: theme.surfaceLight
          }
        },
        footer: {
          paddingTop: "0.5em"
        },
        todayButton: {
          border: "none",
          backgroundColor: "transparent",
          backgroundImage: "none",
          boxShadow: "none",
          color: theme.textBlack,
          fontSize: "0.875em",
          cursor: "pointer"
        },
        today: {
          color: theme.primary
        },
        outside: {
          color: theme.textBlack,
          opacity: 0.8,
          cursor: showOutsideDays ? "pointer" : "default",
          ":hover": {
            background: !showOutsideDays ? "none" : undefined
          }
        },
        selected: {
          backgroundColor: theme.primaryLight,
          ":hover": {
            backgroundColor: theme.primaryLight
          }
        }
      });
    } // Have to export the disabled style to parent component,
    // so that parent can handle disabled state correctly.
    // Because internally, the lib uses the class name to
    // determine whether it's disabled

  }, {
    key: "weekdaysLong",
    get: function get() {
      var _LocalizationStore = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore.i18n;

      return {
        nonZh: [i18n("Sunday"), i18n("Monday"), i18n("Tuesday"), i18n("Wednesday"), i18n("Thursday"), i18n("Friday"), i18n("Saturday")],
        zh: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
      };
    }
  }, {
    key: "weekdaysShort",
    get: function get() {
      var _LocalizationStore2 = new _localization.LocalizationStore(this.context),
          ci18n = _LocalizationStore2.ci18n;

      return {
        nonZh: [ci18n("Short for Sunday, used in calendar", "Su"), ci18n("Short for Monday, used in calendar", "Mo"), ci18n("Short for Tuesday, used in calendar", "Tu"), ci18n("Short for Wednesday, used in calendar", "We"), ci18n("Short for Thursday, used in calendar", "Th"), ci18n("Short for Friday, used in calendar", "Fr"), ci18n("Short for Saturday, used in calendar", "Sa")],
        zh: ["日", "一", "二", "三", "四", "五", "六"]
      };
    }
  }, {
    key: "months",
    get: function get() {
      var _LocalizationStore3 = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore3.i18n;

      return {
        nonZh: [i18n("January"), i18n("February"), i18n("March"), i18n("April"), i18n("May"), i18n("June"), i18n("July"), i18n("August"), i18n("September"), i18n("October"), i18n("November"), i18n("December")],
        zh: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
      };
    }
  }]);
  return DayPicker;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  hideYear: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Hide the year in the title"
  },
  showOutsideDays: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Show days outside the current month"
  },
  selectedDays: {
    required: false,
    defaultValue: "null",
    type: "Date | ReadonlyArray<Date> | ((day: Date) => boolean)",
    description: "Which day(s) are currently selected"
  },
  locale: {
    required: false,
    type: "string",
    description: "The current locale"
  }
}, _class3.demoProps = {
  showOutsideDays: true,
  locale: "en"
}, _class3.discussion = "\n  ## A wrapper for a 3rd-party component `react-day-picker`\n\n  Did some modifications to satisfy our request\n\n  For props, please check http://react-day-picker.tsx.org/api/DayPicker\n\n  The following props are ignored:\n  - `locale`\n  - `localeUtils`\n  - `classNames`\n  - `weekdayElement`\n  ", _class3.disabledStyle = {}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "dayPickerStyles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dayPickerStyles"), _class2.prototype)), _class2)) || _class;

var _default = DayPicker;
exports["default"] = _default;